import {Drawer} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import {IndexPage as ActivityEventsPage} from '../pages/IndexPage';

export const ActivityEventsDrawer = ({
                                         opened,
                                         onClose
                                     }: {
    opened: boolean;
    onClose: () => void;
}) => {
    return (
        <Drawer
            opened={opened}
            onClose={onClose}
            title={I18n.get('Events')}
            position="right"
            size="xl"
        >
            <ActivityEventsPage/>
        </Drawer>
    );
};
